import { render } from "./user-images.vue?vue&type=template&id=817063e4&scoped=true"
import script from "./user-images.vue?vue&type=script&lang=js"
export * from "./user-images.vue?vue&type=script&lang=js"

import "./user-images.vue?vue&type=style&index=0&id=817063e4&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-817063e4"]])

export default __exports__